export const SELF: string = '_self'
